import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCollectionsProfileList extends Layout {
    layoutheaderCollectionsProfileList: LayoutHeader;
    sourceCollectionsProfile: DataSource;
    tableCollectionsProfile: Table;
}
